import { Injectable } from '@angular/core';
import axios from 'axios';
import { Comuna, Region, DireccionRegional } from 'src/app/common/interfaces/region-comuna.interface';
import { AuthService } from '@services/auth/auth.service';
import { BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { Router } from '@angular/router';
import { ToolsService } from '@services/varios/tools.service';

@Injectable({
  providedIn: 'root'
})

export class RegioncomunaService {

  constructor(private readonly authService: AuthService, private readonly router:Router, private readonly toolsService: ToolsService) {}

  public async getRegionesService() : Promise<Region[]> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getRegiones';

    return await axios.get(BASE_URL, {
        headers: {
          Authorization: `Bearer ${UsrInfo.jwt}`,
        },
      }).then(resp => {      
          return resp.data;     
      }).catch(async error =>
        {
          if (error.response.status == 401)
          {
            sessionStorage.clear();
            await this.toolsService.errorSesionMensaje();
            this.router.navigate(['/']);
          }
        });      
    } 

    public async getComunasService() : Promise<Comuna[]> {
      let UsrInfo = this.authService.getUserInfo();
      const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getComunas';
  
      return await axios.get(BASE_URL, {
          headers: {
            Authorization: `Bearer ${UsrInfo.jwt}`,
          },
        }).then(resp => {      
            return resp.data;     
        }).catch(async error =>
          {
            if (error.response.status == 401)
            {
              sessionStorage.clear();
              await this.toolsService.errorSesionMensaje();
              this.router.navigate(['/']);
            }
          });    
      } 

      public async getDireccionesRegionalesService() : Promise<DireccionRegional[]> {
        let UsrInfo = this.authService.getUserInfo();
        const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getDireccionesRegionales';
    
        return await axios.get(BASE_URL, {
            headers: {
              Authorization: `Bearer ${UsrInfo.jwt}`,
            },
          }).then(resp => {      
              return resp.data;     
          }).catch(async error =>
            {
              if (error.response.status == 401)
              {
                sessionStorage.clear();
                await this.toolsService.errorSesionMensaje();
                this.router.navigate(['/']);
              }
            });      
        }
}
